// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n\n/** 存放自定义的变量，可全局直接使用 */\n\n/** 主题色 */\n\n/** 字体样式 */\n\n/** 边框样式 */\n\n/** 错误样式 */\n\n/** 警告样式 */\n\n/** 可复用的模块化样式 */\n\n/**\n * 设置多行文本超出隐藏\n * $n 为规定多少行\n*/\n.el-radio__original {\n  display: none !important;\n  /* 隐藏原生 radio 输入，但仍然允许交互 */\n}\n.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {\n  box-shadow: none !important;\n}", ""]);
// Exports
module.exports = exports;
